'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

exports.default = AgnosticLink;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRouter = require('react-router');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * A link that is either a <Link> or an <IndexLink> based on the `index` property.
 */
function AgnosticLink(_ref) {
  var index = _ref.index,
      props = (0, _objectWithoutProperties3.default)(_ref, ['index']);

  var LinkComponent = props.to ? index ? _reactRouter.IndexLink : _reactRouter.Link : 'a';
  return _react2.default.createElement(LinkComponent, props);
}

AgnosticLink.propTypes = {
  index: _propTypes2.default.bool,
  to: _propTypes2.default.string
};
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@taxfyle/web-commons/lib/components/Link/index.js
// module id = 64
// module chunks = 0